import { useAuth } from '@wlb/shared/context/AuthContext';
import { useTranslation } from '@wlb/shared/i18n/useTranslation';
import { Button } from '../ui/Button';
import { Modal } from '../ui/Modal';

/**
 * Shown when `apiClient` cannot refresh the session any more. Confirming clears
 * the session, and the route guard sends the operator back to /login.
 */
export function SessionExpiredModal() {
  const { t } = useTranslation('admin');
  const { sessionExpiredVisible, confirmSessionExpiredAndLogout } = useAuth();

  return (
    <Modal
      open={sessionExpiredVisible}
      title={t('session.expiredTitle')}
      description={t('session.expiredMessage')}
      onClose={confirmSessionExpiredAndLogout}
      footer={
        <Button onClick={confirmSessionExpiredAndLogout}>
          {t('session.expiredConfirm')}
        </Button>
      }
    />
  );
}
